/**
 * Marketing-funnel tracking helper.
 *
 * Best-effort POST /v1/funnel with the lead's anonId (cookie-style random id
 * persisted across visits via localStorage) so we can correlate the same
 * visitor's pricing_view → register_submit pair even when the user is
 * unauthenticated.
 *
 * Failures are swallowed — analytics shouldn't break the app.
 */

function anonId(): string | null {
  try {
    let id = localStorage.getItem("clearbooks.anonId");
    if (!id) {
      id = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `a${Math.random().toString(36).slice(2)}${Date.now()}`;
      localStorage.setItem("clearbooks.anonId", id);
    }
    return id;
  } catch {
    return null;
  }
}

/**
 * Read the variant the pricing page assigned this visitor. Persisted across
 * the SPA boundary via localStorage so downstream events stay tagged.
 */
function activeVariant(): { experiment_key: string; variant: string } | null {
  try {
    const raw = localStorage.getItem("clearbooks.activeVariant");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function trackFunnel(kind: string, meta?: Record<string, unknown>): void {
  try {
    const variant = activeVariant();
    void fetch("/clearbooks/api/funnel", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        kind,
        anon_id: anonId(),
        path: typeof location !== "undefined" ? location.pathname : null,
        referrer: typeof document !== "undefined" ? (document.referrer || null) : null,
        meta: { ...(variant ?? {}), ...(meta ?? {}) },
      }),
      keepalive: true,
    });
  } catch {
    /* analytics shouldn't break the app */
  }
}
